export const FirebaseConfig = {
	"projectId": "taxilab2022",
	"appId": "1:910210717472:web:f0770dfefe866ddfb56945",
	"databaseURL": "https://taxilab2022-default-rtdb.firebaseio.com",
	"storageBucket": "taxilab2022.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBLtwFOCt5Erf0YHJB0jLnQU8NzPhp_CQQ",
	"authDomain": "taxilab2022.firebaseapp.com",
	"messagingSenderId": "910210717472",
	"measurementId": "G-LC4JBY8B97"
};